module.exports = __webpack_public_path__ + "static/media/lueurgenerateur.5e5db4bc.png";